import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AuthorizationService, Permissions } from '@rocksoft/shared/authorization';
import { Observable } from 'rxjs';
import { DeviceMdmSyncForceComponent } from './device-mdm-sync-force.component';
import { ForceSyncService } from './device-mdm-sync-force.service';

@Component({
  selector: 'era-device-mdm-sync-force',
  templateUrl: './device-mdm-sync-force.container.html',
  styleUrls: ['./device-mdm-sync-force.container.scss'],
  imports: [DeviceMdmSyncForceComponent, AsyncPipe],
})
export class DeviceMdmSyncForceContainerComponent {
  private readonly authorizationService = inject(AuthorizationService);
  private readonly forceSyncService = inject(ForceSyncService);

  public readonly isAuthorized$: Observable<boolean>;

  constructor() {
    // Permissions.InternalRegionalOrAdmin allows both Admin and InternalRegional roles
    this.isAuthorized$ = this.authorizationService.getIsAuthorized$(Permissions.InternalRegionalOrAdmin);
  }

  updateForceSync(forceSync: boolean): void {
    this.forceSyncService.setForceSync(forceSync);
  }
}
